import "./src/styles/global.scss"